const UNITS = ["B", "KB", "MB", "GB", "TB"];

/**
 * Human-readable file size, base 1024 like the OS file managers show it.
 * @example formatBytes(2585234472, "de") // "2,41 GB"
 */
export default function formatBytes(bytes: number, language?: string): string {
	if (!Number.isFinite(bytes) || bytes <= 0) {
		return "0 B";
	}

	const exponent = Math.min(
		Math.floor(Math.log(bytes) / Math.log(1024)),
		UNITS.length - 1,
	);
	const value = bytes / 1024 ** exponent;
	const digits = exponent >= 3 ? 2 : exponent === 0 ? 0 : 1;

	const formatted = new Intl.NumberFormat(language, {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	}).format(value);

	return `${formatted} ${UNITS[exponent]}`;
}
